import React from "react";
import Hero from "../components/Hero";

function Home({ loading, setLoading }) {
  return (
    <div>
      <Hero loading={loading} setLoading={setLoading} />
    </div>
  );
}

export default Home;
